/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zombie_Logo_AltInputs */

const en_zombie_logo_alt = /** @type {(inputs: Zombie_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZombieTrend AI logo`)
};

const zh_zombie_logo_alt = /** @type {(inputs: Zombie_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZombieTrend AI 标志`)
};

/**
* | output |
* | --- |
* | "ZombieTrend AI logo" |
*
* @param {Zombie_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const zombie_logo_alt = /** @type {((inputs?: Zombie_Logo_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zombie_Logo_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_zombie_logo_alt(inputs)
	return zh_zombie_logo_alt(inputs)
});
export { zombie_logo_alt as "zombie.logo_alt" }